export default {

  // 新增生产过程检查
  insertPaProductionInspection: '/ygsjzs/paProductionInspection/insertPaProductionInspection',

  // 修改生产过程检查/
  updatePaProductionInspection: '/ygsjzs/paProductionInspection/updatePaProductionInspection',

  // 删除生产过程检查
  deletePaProductionInspection: '/ygsjzs/paProductionInspection/deletePaProductionInspection',

  // 查询生产过程检查详情
  selectPaProductionInspectionByCheckId: '/ygsjzs/paProductionInspection/selectPaProductionInspectionByCheckId',

  // 分页查询生产过程检查列表
  selectPaProductionInspectionByPage: '/ygsjzs/paProductionInspection/selectPaProductionInspectionByPage'
}
